import react, { useEffect, useState } from "react";
import MenuEmpresas from "./menuempresas";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import axios from "axios";
import Avatar from "@mui/joy/Avatar";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import FormHelperText from "@mui/joy/FormHelperText";
import Input from "@mui/joy/Input";
import Textarea from "@mui/joy/Textarea";
import Autocomplete from "@mui/joy/Autocomplete";
import Chip from "@mui/joy/Chip";
import Divider from "@mui/joy/Divider";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Badge from "@mui/joy/Badge";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

let Header = ({
  foto,
  nombre,
  tipo,
  datosEmpresa,
  descripcion,
  modificarFormulario,
  vistaPrevia,
  subirFoto,
  enviarFormulario,
  loading,
  deshabilitar,
}) => {
  const inputRef = react.useRef(null);

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "#f0f4f8",
          borderRadius: 5,
          padding: 3,
          marginTop: 2,
          display: "grid",
          gap: 3,
          justifyContent: "flex-start",
          width: "70%",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#133524",
            borderRadius: "12px",
            padding: 3,
            width: "100%",
            display: "flex",
            maxWidth: 340,
            gap: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box>
            <Badge
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              badgeInset="14%"
              variant="plain"
              badgeContent={
                <PhotoCameraIcon
                  sx={{
                    color: "#133524",
                  }}
                />
              }
            >
              <input
                ref={inputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={subirFoto}
              />
              <Avatar
                alt="Foto de Perfil"
                src={vistaPrevia ? vistaPrevia : foto}
                sx={{
                  "--Avatar-size": "8vw",
                  border: 2,
                  borderColor: "white",
                  cursor: "pointer",
                  transition: "0.2s",

                  "& img": {
                    transition: "0.2s",
                  },

                  "&:hover img": {
                    filter: "brightness(0.6)",
                  },
                }}
                onClick={() => {
                  inputRef.current.click();
                }}
              />
            </Badge>
            <Chip
              size="sm"
              variant="soft"
              color="neutral"
              sx={{
                border: "3px solid",
                borderColor: "background.surface",
                bottom: 10,
                left: 25,
              }}
            >
              {tipo}
            </Chip>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: 200, // o el ancho que quieras
              overflow: "hidden",
              minWidth: 200,
            }}
          >
            <Typography sx={{ color: "white" }} level="title-sm">
              {nombre}, {datosEmpresa.pais}
            </Typography>
            <Typography
              sx={{ color: "white", fontStyle: "italic" }}
              level="body-xs"
            >
              {descripcion.slice(0, 80)}...
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "grid", gap: 2 }}>
          <Typography level="title-sm">Sobre tu perfil</Typography>
          <Divider />

          <Box sx={{ display: "flex", gap: 5 }}>
            <FormControl>
              <FormLabel>Razón Social</FormLabel>
              <Input disabled value={datosEmpresa.razon_social} size="sm" />
            </FormControl>
            <FormControl>
              <FormLabel>R.U.T.</FormLabel>
              <Input disabled value={datosEmpresa.rut} size="sm" />
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", gap: 5 }}>
            <FormControl>
              <FormLabel>Marca</FormLabel>
              <Input disabled value={datosEmpresa.nombre_comercial} size="sm" />
            </FormControl>
            <FormControl>
              <FormLabel>Teléfono</FormLabel>
              <Input disabled value={datosEmpresa.telefono} size="sm" />
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", gap: 5 }}>
            <FormControl>
              <FormLabel>Correo</FormLabel>
              <Input disabled value={datosEmpresa.correo} size="sm" />
            </FormControl>
            <FormControl>
              <FormLabel>Sitio web</FormLabel>
              <Input disabled value={datosEmpresa.sitio_web} size="sm" />
            </FormControl>
          </Box>
          <Box sx={{ display: "grid", gap: 1 }}>
            <FormControl>
              <FormLabel>Descripción</FormLabel>
              <Textarea
                value={descripcion}
                size="sm"
                minRows={4}
                onChange={(event) => {
                  modificarFormulario(event, "descripcion");
                }}
              />
            </FormControl>
          </Box>

          <Button
            variant="outlined"
            color="neutral"
            onClick={() => {
              enviarFormulario();
            }}
            loading={loading}
            disabled={deshabilitar}
          >
            Actualizar perfil
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function InformacionCuentaEmpresas() {
  let [cuenta, setCuenta] = react.useState();
  let [tipo, setTipo] = react.useState();
  let [usuario, setUsuario] = react.useState();
  let [categorias, setCategorias] = react.useState();
  let [vistaPrevia, setVistaPrevia] = react.useState(false);
  let [formDataEmpresa, setFormDataEmpresa] = react.useState({
    descripcion: "",
    foto_perfil: "",
  });
  let [loading, setLoading] = react.useState(false);
  let [deshabilitar, setDeshabilitar] = react.useState(false);
  useEffect(() => {
    if (formDataEmpresa.descripcion.length === 0) {
      setDeshabilitar(true);
    }
    if (formDataEmpresa.descripcion.length > 0) {
      setDeshabilitar(false);
    }
  }, [formDataEmpresa]);

  useEffect(() => {
    async function getInformacion() {
      let token = localStorage.getItem("token");

      let getInfoCuenta = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/api/escritorio/informacion-cuenta`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCuenta(getInfoCuenta.data.data);
      setFormDataEmpresa({
        telefono: getInfoCuenta.data.data.telefono,
        descripcion: getInfoCuenta.data.data.descripcion,
        foto_perfil: getInfoCuenta.data.data.foto_perfil,
      });
      setTipo("Empresa");
      setUsuario(getInfoCuenta.data.usuario);
    }
    getInformacion();
  }, []);

  useEffect(() => {
    async function getInformacion() {
      let getCategorias = await axios.get(
        `${process.env.REACT_APP_FRONTEND_URL}/api/categorias`
      );
      setCategorias(getCategorias.data);
    }
    getInformacion();
  }, []);

  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  const manejarSubirFoto = async (event) => {
    const archivo = event.target.files[0];
    if (archivo) {
      let opciones = {
        maxSizeMB: 1, // Máximo 1MB
        maxWidthOrHeight: 1024, // Redimensionar si es necesario
        useWebWorker: true,
      };
      try {
        let imagenRecibida = archivo;
        /* EN CASO DE ARCHIVOS .HEIC */

        if (
          imagenRecibida.type === "image/heic" ||
          imagenRecibida.type === "image/heif"
        ) {
          let blob = await heic2any({
            blob: archivo,
            toType: "image/jpeg",
            quality: 0.8,
          });
          imagenRecibida = new File([blob], "imagen_convertida.jpg", {
            type: "image/jpeg",
          });
        }

        /* EN CASO DE ARCHIVOS .HEIC */

        let imagenComprimida = await imageCompression(imagenRecibida, opciones);

        // Convertir a JPG si el formato es diferente
        const imagenBlob = await imageCompression(imagenComprimida, {
          fileType: "image/jpeg",
        });

        // Crear un nuevo archivo JPG
        const imagenJPG = new File([imagenBlob], "imagen.jpg", {
          type: "image/jpeg",
        });

        setFormDataEmpresa((valoranterior) => ({
          ...valoranterior,
          foto_perfil: imagenJPG,
        }));
        setVistaPrevia(URL.createObjectURL(imagenJPG));
      } catch (err) {
        console.log("Tenemos un error para procesar la fotografía " + err);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (vistaPrevia) {
        URL.revokeObjectURL(vistaPrevia);
      }
    };
  }, [vistaPrevia]);
  /* SUBIR FOTO LO HIZO CHATGPT  JUNTO CON COMPRESION DE IMAGEN Y CONVERSIÓN DE ARCHIVO*/

  async function enviarFormulario() {
    try {
      setLoading(true);
      console.log(formDataEmpresa);
      let token = localStorage.getItem("token");

      let formData = new FormData();

      formData.append("descripcion", formDataEmpresa.descripcion);
      formData.append("foto_perfil", formDataEmpresa.foto_perfil);
      formData.append("tipo", "empresa");

      let enviarInformacion = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/api/escritorio/modificar-cuenta`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (err) {
      setLoading(false);
      console.log("tenemos un error al enviar el formulario");
    }
  }

  function modificarFormulario(valor, tipo) {
    if (tipo === "descripcion") {
      setFormDataEmpresa((x) => ({
        ...x,
        descripcion: valor.target.value.slice(0, 200),
      }));
    }
  }

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Box
          sx={{
            width: "47vw",
            height: "100vh",
            padding: 20,
            paddingTop: 5,
          }}
        >
          <Typography level="title-lg">Información de mi cuenta</Typography>
          <Typography level="body-sm" sx={{ marginTop: 0.5 }}>
            Administra y actualiza la información pública de tu perfil como{" "}
            {tipo}
          </Typography>
          {cuenta ? (
            <Header
              foto={`${process.env.REACT_APP_DOSPACES}/uploads/${formDataEmpresa.foto_perfil}`}
              nombre={cuenta.razon_social}
              tipo={tipo}
              datosEmpresa={cuenta}
              descripcion={formDataEmpresa.descripcion}
              especialidades={formDataEmpresa.especialidadesGuia}
              categorias={categorias}
              modificarFormulario={modificarFormulario}
              vistaPrevia={vistaPrevia}
              subirFoto={manejarSubirFoto}
              enviarFormulario={enviarFormulario}
              loading={loading}
              deshabilitar={deshabilitar}
            />
          ) : null}
        </Box>
        <Box sx={{ width: "47vw", height: "100vh" }}></Box>
      </Box>

      <MenuEmpresas />
    </Box>
  );
}
